export default __webpack_public_path__ + "static/media/bullet.2275e770.svg";